var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('cookie-law',{attrs:{"message":_vm.$t('cookie_consent.message'),"buttonText":_vm.$t('cookie_consent.button'),"theme":"fleetware"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }